import { AbsoluteFill, Sequence } from "remotion";
import { SCENE, COLORS } from "./constants";
import { Scene01ColdOpen } from "./Scene01ColdOpen";
import { Scene02Title } from "./Scene02Title";
import { Scene03Trio } from "./Scene03Trio";
import { Scene04FounderProblem } from "./Scene04FounderProblem";
import { Scene05FounderSolve } from "./Scene05FounderSolve";
import { Scene06WorkerProblem } from "./Scene06WorkerProblem";
import { Scene07WorkerSolve } from "./Scene07WorkerSolve";
import { Scene08CSProblem } from "./Scene08CSProblem";
import { Scene09CSSolve } from "./Scene09CSSolve";
import { Scene10Close } from "./Scene10Close";
import { Scene11Outro } from "./Scene11Outro";

export const EAKCMarketBrief: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: COLORS.bg }}>
      <Sequence from={SCENE.open.start}         durationInFrames={SCENE.open.duration}><Scene01ColdOpen /></Sequence>
      <Sequence from={SCENE.title.start}        durationInFrames={SCENE.title.duration}><Scene02Title /></Sequence>
      <Sequence from={SCENE.trio.start}         durationInFrames={SCENE.trio.duration}><Scene03Trio /></Sequence>
      <Sequence from={SCENE.founderProb.start}  durationInFrames={SCENE.founderProb.duration}><Scene04FounderProblem /></Sequence>
      <Sequence from={SCENE.founderSolve.start} durationInFrames={SCENE.founderSolve.duration}><Scene05FounderSolve /></Sequence>
      <Sequence from={SCENE.workerProb.start}   durationInFrames={SCENE.workerProb.duration}><Scene06WorkerProblem /></Sequence>
      <Sequence from={SCENE.workerSolve.start}  durationInFrames={SCENE.workerSolve.duration}><Scene07WorkerSolve /></Sequence>
      <Sequence from={SCENE.csProb.start}       durationInFrames={SCENE.csProb.duration}><Scene08CSProblem /></Sequence>
      <Sequence from={SCENE.csSolve.start}      durationInFrames={SCENE.csSolve.duration}><Scene09CSSolve /></Sequence>
      <Sequence from={SCENE.close.start}        durationInFrames={SCENE.close.duration}><Scene10Close /></Sequence>
      <Sequence from={SCENE.outro.start}        durationInFrames={SCENE.outro.duration}><Scene11Outro /></Sequence>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
